import { inject, Injectable } from '@angular/core';
import { Upgrade } from '@core/models';
import { PrivateSellingService } from '@core/services/private-selling.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpgradesService {
  private privateSellingService = inject(PrivateSellingService);

  upgrades: Upgrade[];
  totalCartAndFiltersSeats$ = new Subject<number>(); // Cada vez que cambia (se hace un ".next") se lanza el this.checkTotalSeatsForUpgrades(totalCartSeats) desde upgrades.component.ts
  upgradesCall: ReturnType<typeof setTimeout>;

  reachingUpgrade: Upgrade | null = null;
  acquiredUpgrade: Upgrade | null = null;

  availableUpgrades: Upgrade[] = [];
  acquiredUpgrades: Upgrade[] = [];
  previousTotalSeats: number;

  sendLastUpgradesCall(numSeats: number) {
    if (this.upgradesCall) {
      clearTimeout(this.upgradesCall);
    }
    // Updating totalCartAndFiltersSeats number for Upgrades
    this.upgradesCall = setTimeout(() => {
      this.totalCartAndFiltersSeats$.next(numSeats);
    }, 1000);
  }

  sortUpgradesByGoal(upgrades: Upgrade[]) {
    if (upgrades?.length) {
      upgrades.sort((a, b) => a.goal - b.goal);
    }
  }

  checkCartSeatsForUpgradesList(totalCartSeats: number) {
    if (!this.upgrades?.length) return;

    this.sortUpgradesByGoal(this.upgrades);
    // Reset Upgrades lists, available and acquired
    this.availableUpgrades = [];
    this.acquiredUpgrades = [];

    for (const upgrade of this.upgrades) {
      // Set Upgrades lists, available and acquired
      if (upgrade.goal <= totalCartSeats) {
        this.acquiredUpgrades.push(upgrade);
      } else {
        this.availableUpgrades.push(upgrade);
      }
    }
  }

  checkTotalSeatsForUpgradesMessages(totalSeats: number) {
    if (!this.upgrades?.length) return;
    if (
      this.privateSellingService.isEnabled() &&
      !this.privateSellingService.isUserInWhitelist()
    ) {
      return;
    }

    this.sortUpgradesByGoal(this.upgrades);

    let availableUps = [];
    let acquiredUps = [];
    for (const upgrade of this.upgrades) {
      // Set Upgrades lists, available and acquired
      if (upgrade.goal <= totalSeats) {
        acquiredUps.push(upgrade);
      } else {
        availableUps.push(upgrade);
      }
    }

    for (const upgrade of this.upgrades) {
      // Si el num seats coincide con un Goal
      if (upgrade.goal === totalSeats) {
        this.acquiredUpgrade = upgrade;
        setTimeout(() => (this.acquiredUpgrade = null), 3000);
        // Si el num seats coincide con un minSeatsToShow
      } else if (upgrade.minSeatsToShow === totalSeats) {
        this.reachingUpgrade = upgrade;
        setTimeout(() => (this.reachingUpgrade = null), 3000);
      }
    }

    // Si el num seats tiene una diferencia con el num previo de más de 1 (se ha introducido por el input manualmente)
    if (
      this.previousTotalSeats - totalSeats < -1 ||
      this.previousTotalSeats - totalSeats > 1
    ) {
      if (availableUps[0] && availableUps[0].minSeatsToShow < totalSeats) {
        this.reachingUpgrade = availableUps[0];
        setTimeout(() => (this.reachingUpgrade = null), 3000);
      }
    }

    // Store previous seats count
    this.previousTotalSeats = totalSeats;
  }
}
